import React from "react"

/**
 * Situations — "Wherever you're starting from", src/Design/industries/
 * situations-section.html. Replaces Solution.js/.isolution on six of the
 * seven industry pages (not real estate, which keeps Solution.js as-is).
 * Sits in the same place: after challenges, before results.
 *
 * cards: [{ tag, title, detail, ghostIconPath, footerText, footerHref }] —
 * exactly four, one per fixed card colour (1 navy, 2 teal, 3 purple,
 * 4 orange, via the isituations__card--N modifier). ghostIconPath is raw
 * SVG path markup for the single faded background icon, same style as
 * ChallengeGrid/Solution's icons (viewBox 0 0 24 24, stroke-based).
 */
const ARROW_PATH = '<path d="M5 12h14M13 6l6 6-6 6"/>'

const SituationsSection = ({
  eyebrow,
  heading,
  intro,
  cards = [],
  unsureHeading,
  unsureDetail,
  unsureLinkLabel,
  unsureLinkHref,
}) => (
  <section className="isituations">
    <div className="isituations__inner">
      <div className="isituations__head">
        <div>
          <p className="isituations__eyebrow">{eyebrow}</p>
          <h2 className="isituations__heading">{heading}</h2>
        </div>
        <p className="isituations__intro">{intro}</p>
      </div>

      <div className="isituations__cards">
        {cards.map((c, i) => (
          <article className={`isituations__card isituations__card--${i + 1}`} key={c.title}>
            <div className="isituations__card-top">
              <span className="isituations__tag">{c.tag}</span>
              <svg
                className="isituations__ghost"
                viewBox="0 0 24 24"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: c.ghostIconPath }}
              />
              <div className="isituations__card-body">
                <h3 className="isituations__card-title">{c.title}</h3>
                <p className="isituations__card-detail">{c.detail}</p>
              </div>
            </div>
            <a
              className="isituations__card-foot"
              href={c.footerHref}
              {...(/^https?:\/\//.test(c.footerHref) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              <span>{c.footerText}</span>
              <svg
                className="isituations__arrow"
                viewBox="0 0 24 24"
                width="22"
                height="22"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: ARROW_PATH }}
              />
            </a>
          </article>
        ))}
      </div>

      <div className="isituations__unsure">
        <div>
          <strong className="isituations__unsure-title">{unsureHeading}</strong>
          <span className="isituations__unsure-detail">{unsureDetail}</span>
        </div>
        <a className="isituations__unsure-link" href={unsureLinkHref}>
          {unsureLinkLabel}
        </a>
      </div>
    </div>
  </section>
)

export default SituationsSection
